/**
 * Tiny crown badge that appears next to a premium user's display name.
 * Pass `tier` ('premium' | 'unlimited' | 'free') or a boolean `premium`
 * prop. Renders nothing for free users.
 *
 *   <PremiumCrown tier={user.tier} />
 *   <PremiumCrown premium />
 */
export default function PremiumCrown({ tier, premium, size = 'sm', title }) {
  const isPremium = premium || tier === 'premium' || tier === 'unlimited';
  if (!isPremium) return null;
  const isUnlimited = tier === 'unlimited';
  return (
    <span
      className={`premium-crown premium-crown-${size}`}
      title={title || (isUnlimited ? 'Unlimited member' : 'Premium member')}
      aria-label={isUnlimited ? 'Unlimited member' : 'Premium member'}
      role="img"
    >
      👑
    </span>
  );
}
